import React, { ChangeEvent, useState } from 'react';
import { Select } from '@increasecard/typed-components';
import { useTranslation } from 'react-i18next';
import { TFunction } from 'i18next';

const options = (translationFunction: TFunction) => [
  {
    value: 'UNINITIATED',
    shown: translationFunction('chargebacks:List:fields:status:options_labels:uninitiated')
  },
  {
    value: 'INITIATED',
    shown: translationFunction('chargebacks:List:fields:status:options_labels:initiated')
  },
  {
    value: 'RECOVERED',
    shown: translationFunction('chargebacks:List:fields:status:options_labels:recovered')
  },
  {
    value: 'DISCARDED',
    shown: translationFunction('chargebacks:List:fields:status:options_labels:discarded')
  }
];

type StatusProps = {
  onStatusSelected: (field: string, value: string) => void;
  value: string;
};

const Status = ({ onStatusSelected, value }: StatusProps) => {
  const [status, setStatus] = useState(value);
  const { t } = useTranslation();
  const onChangeSelectStatus = (event: ChangeEvent<HTMLSelectElement>) => {
    setStatus(event.currentTarget.value);
    onStatusSelected('status', event.currentTarget.value);
  };
  return (
    <Select
      id="chargebacksStatus"
      label=""
      labelHidden
      onChange={onChangeSelectStatus}
      value={status}
    >
      {options(t).map((status, index) => (
        <option key={index} value={status.value}>
          {status.shown}
        </option>
      ))}
    </Select>
  );
};

export default Status;
